import { useMemo } from "react";

export default function useAppConfig(management, key) {
  const configs = JSON.parse(localStorage.getItem("app_configs") || "[]");

  return useMemo(() => {
    return (
      configs.find(
        (item) => item.management === management && item.key === key
      ) || {}
    );
  }, [management, key]);
}
